import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { GuardProvider } from "@/context/GuardContext";
import { ConfirmProvider } from "@/context/ConfirmContext";
import { CreerRdvProvider } from "@/components/CreerRdv";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Agenda from "@/pages/Agenda";
import Patients from "@/pages/Patients";
import Soins from "@/pages/Soins";
import PatientsSuivi from "@/pages/PatientsSuivi";
import PatientDetail from "@/pages/PatientDetail";
import FicheSoin from "@/pages/FicheSoin";
import Tournees from "@/pages/Tournees";
import TourneeDetail from "@/pages/TourneeDetail";
import RelationClient from "@/pages/RelationClient";
import Piloter from "@/pages/Piloter";
import PiloterPaiements from "@/pages/PiloterPaiements";
import PiloterExports from "@/pages/PiloterExports";
import Parametres from "@/pages/Parametres";
import Prestations from "@/pages/Prestations";
import Portail from "@/pages/Portail";
import JourJ from "@/pages/JourJ";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <GuardProvider>
          <ConfirmProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portail/:token" element={<Portail />} />
            <Route path="/t/:token" element={<Portail />} />
            <Route path="/jour-j/:date" element={<JourJ />} />
            <Route path="/payment/success" element={<PaymentResult ok />} />
            <Route path="/payment/cancel" element={<PaymentResult ok={false} />} />
            <Route element={<Protected><CreerRdvProvider><Layout /></CreerRdvProvider></Protected>}>
              <Route index element={<Navigate to="/agenda" replace />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/patients" element={<Patients />} />
              <Route path="/patients/suivi" element={<PatientsSuivi />} />
              <Route path="/patients/soins" element={<Soins />} />
              <Route path="/patients/:id" element={<PatientDetail />} />
              <Route path="/parametres/:section" element={<Parametres />} />
              <Route path="/fiche-soin/:id" element={<FicheSoin />} />
              <Route path="/soins/:id" element={<FicheSoin />} />
              <Route path="/tournees" element={<Tournees />} />
              <Route path="/tournees/:id" element={<TourneeDetail />} />
              <Route path="/relation" element={<RelationClient />} />
              <Route path="/piloter" element={<Piloter />} />
              <Route path="/piloter/paiements" element={<PiloterPaiements />} />
              <Route path="/piloter/exports" element={<PiloterExports />} />
              <Route path="/parametres" element={<Parametres />} />
              <Route path="/parametres/:section" element={<Parametres />} />
              <Route path="/prestations" element={<Navigate to="/parametres/catalogue" replace />} />
            </Route>
            <Route path="*" element={<Navigate to="/agenda" replace />} />
          </Routes>
          </ConfirmProvider>
          </GuardProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
